import { connect } from 'react-redux';
import CartIcon from '../../components/CartIcon';

const mapStateToProps = state => ({
  cartAmount: state.cart.length
});

export default connect(mapStateToProps)(CartIcon);
